import { filterNodesFromPosition } from '../../modules/player';
import { selectNode } from '../../modules/selection';

export default function select(store, translator) {
  return {
    label: 'Select',
    enabled: true,
    display: {
      playerTools: false,
    },
    options: {},

    tool: {
      click: function (ev) {
        const nodes = filterNodesFromPosition(store, ev);
        if (nodes.length) store.dispatch(selectNode(nodes[0]));
      },

      drag: function (ev) {
        if (ev.which !== 1 || !this.active) return false;

        return {
          momentum: false,

          handle: function (ev) {
            //console.log('drag select', ev.deltaX, ev.deltaY);
          },
        };
      },
    },
  };
};



// WEBPACK FOOTER //
// ./src/translators/tools/select.js